import {useRef, useState} from 'react';
import useDimensionsListener from './useDimensionsListener';

export default function useDimensions() {
  const ref = useRef(null);
  const [boundingRect, setBoundingRect] = useState({
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: 0,
    height: 0,
  });

  useDimensionsListener(ref, setBoundingRect);

  return {
    elementRef: ref,
    width: boundingRect.width || 0,
    height: boundingRect.height || 0,
    top: boundingRect.top || 0,
    bottom: boundingRect.bottom || 0,
    right: boundingRect.right || 0,
    left: boundingRect.left || 0,
  };
}
